<template>
  <div class="activityLists clearfix">
    <div
      class="activityBox"
      v-for="(item, i) in list"
      :key="i"
      @click="gotoActivityDetail(item.id)"
    >
      <div class="imgBox">
        <img class="imgs" :src="item.thumb | imageUrl('', 396, 528)" alt="" />
        <span class="ad" v-if="item.type==2">{{ $t("video.广告") }}</span>
      </div>
      <div class="title">
        <p class="content">{{ item.title }}</p>
        <p class="time">
          {{ item.holdStartTime | formatDate("YYYY.MM.DD") }} -
          {{ item.holdEndTime | formatDate("YYYY.MM.DD") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "activityLists",
  data() {
    return {};
  },
  methods: {
    gotoActivityDetail(id) {
      let routeData = this.$router.resolve({
        path: "/activityDetail/" + id,
      });
      window.open(routeData.href, "_blank");
    },
  },
  props: {
    list: Array,
  },
  created() {},
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.activityLists {
  width: 1110px;

  .activityBox {
    width: 198px;
    float: left;
    margin-right: 30px;
    cursor: pointer;

    &:nth-child(5) {
      margin-right: 0;
    }

    .imgBox {
      width: 198px;
      height: 264px;
      position: relative;

      .imgs {
        width: 100%;
        height: 100%;
      }

      .ad {
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 0 4px;
        height: 16px;
        text-align: center;
        background: rgba(51, 51, 51, 0.4);
        border-radius: 0px 6px 0px 0px;
        line-height: 16px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .title {
      width: 198px;

      .content {
        width: 198px;
        min-height: 22px;
        font-size: 15px;
        font-weight: 600;
        color: #0A0A0A;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
        margin: 10px 0 6px 0;
      }

      .time {
        height: 21px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/activityLists.vue